import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  resourceType: null,
  resourceId: null,
  notes: null,
};

const context = createContext();

export function ContextProvider({ resourceType, resourceId, children }) {
  initialState.resourceType = resourceType;
  initialState.resourceId = resourceId;
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  resourceType: PropTypes.string.isRequired,
  resourceId: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};

export const useContext = () => React.useContext(context);
